module.exports = __webpack_public_path__ + "img/4_5.0b5b492f.png";